// extracted by mini-css-extract-plugin
export default {"remove":"ApprovedComponent_remove__k8BmD","comment":"ApprovedComponent_comment__jVIVs"};